import { EyeIcon, EyeSlashIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { IconButton } from '@mui/material';
import { ReactElement, useState } from 'react';
import { useField } from 'formik';

import { PoolTextfield, PoolTextfieldProps } from '.';

export const PoolFormikPasswordField = (props: PoolTextfieldProps & { name: string }): ReactElement => {
    const { name, ...textFieldProps } = props;
    const [field, meta] = useField({ name });
    const [isVisible, setIsVisible] = useState(false);

    const handleToggle = (): void => {
        setIsVisible(!isVisible);
    };

    return (
        <PoolTextfield
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : ' '}
            {...field}
            {...textFieldProps}
            type={isVisible ? 'text' : 'password'}
            endAdornment={
                <IconButton size="large" onClick={handleToggle} color="dark">
                    {isVisible ? <EyeSlashIcon /> : <EyeIcon />}
                </IconButton>
            }
        />
    );
};
